import { render, staticRenderFns } from "./widget-place.vue?vue&type=template&id=340406a8&scoped=true"
import script from "./widget-place.vue?vue&type=script&lang=ts"
export * from "./widget-place.vue?vue&type=script&lang=ts"
import style0 from "./widget-place.vue?vue&type=style&index=0&id=340406a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340406a8",
  null
  
)

export default component.exports